<template>
  <div class="text-center">
    <p><img width="150" src="@/assets/images/user-created.svg"></p>
    <h2>Welcome on board!</h2>
    <p>An email is on its way to verify your email address <strong>{{ $store.state.register.data.email }}</strong>. Please check your inbox and click the link contained in the email.</p>
  </div>
</template>
